import { AuditingTable } from "components/auditing";
import { NotificationToaster } from "components/notifications";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { EmployeeReviewTypesService } from "services";

export function ReviewTypeHistory({ reviewTypeId }) {
    const noDataMessage = "It looks like no previous changes have been made to the review type.";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const onTableChange = (pageSize, pageNumber, startDate, endDate) => {
        setLoading(true);
        EmployeeReviewTypesService.getReviewTypeChangeLog(reviewTypeId, pageSize, pageNumber, startDate, endDate)
            .then((r) => {
                setTableData(r.data);
                setTableRecordCount(r.totalCount);
            })
            .catch(() => {
                setTableData([]);
                NotificationToaster.show(Intent.DANGER, "Failed to load the review type history. Please try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <AuditingTable
            data={tableData}
            totalCount={tableRecordCount}
            onChange={onTableChange}
            allowClear={false}
            loading={loading}
            noDataMessage={noDataMessage}>
        </AuditingTable>
    );
}

ReviewTypeHistory.propTypes = {
    reviewTypeId: PropTypes.string.isRequired
};
